<template>
  <div class="the-nav">
    <div class="the-container">
      <NuxtLink
        :class="{ hide: collapsed }"
        class="logo"
        to="/"
        @click="onClickLogo"
      >
        <TheLogo class="icon" />
        <div class="sr-only">Videlio Home</div>
      </NuxtLink>

      <TheNavBar
        :items="nav.content.items"
        :collapsed="collapsed"
      />

      <!-- <div class="nav-bar type-body3">
        <div
          class="nav-bar-item"
          v-for="item in nav.content.items"
          :key="item._uid"
        >
          <Cta :blok="item">
            <span class="label">{{ item.label }}</span>
          </Cta>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
// import IconLogo from "@/icons/logo-small.svg?component"
const props = defineProps({})

const emits = defineEmits([])

const config = useRuntimeConfig()
const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()
const env = useEnv()
const route = useRoute()

const refRoot = ref(null)

let opts = {}
if (config.public.SB_VERSION == "draft") {
  opts.version = "draft"
}
const nav = await useStory("/global/the-nav", opts)

// ************************************************************
// Collapsed
// ************************************************************
const collapsed = ref(false)

onMounted(() => {
  if (env.isMobile) {
    collapsed.value = true
  }
})

const onScroll = (scroller) => {
  if (env.isMobile) return
  // console.log(scroller.lastVelocity)
  if (scroller.velocity == 0) return
  collapsed.value = scroller.velocity >= 0
  // if (scroller.lastVelocity) {
  // }
  // collapsed.value = app.scroller.targetScroll > 10
}
onMounted(() => {
  app.scroller.on("scroll", onScroll)
})
onUnmounted(() => {
  app.scroller.off("scroll", onScroll)
})

const onClickLogo = () => {
  if (route.path == "/") {
    app.scroller.scrollTo(0)
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.the-nav {
  position: fixed;
  width: 100%;
  z-index: 100;
  pointer-events: none;
}

.the-container {
  height: var(--nav-height);
  @include flex(row, space-between, center);
}

.logo {
  display: block;
  transition: opacity 0.4s ease;

  :deep(.icon) {
    height: 1.865rem * 2;
    @include mobile {
      height: 1.68rem * 2;
    }
  }

  &.hide {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
